import styled from '@emotion/styled';
import { Radio } from '@kc-console/common-ui';

const DataTableRadio = styled(Radio)``;

export default DataTableRadio;
